// extracted by mini-css-extract-plugin
export default {"rightIconColor":"hJCLdd4QPxgAViERvo70","languagePopup":"vkOaE4Cp9XNl_VLeAUAg"};